import { postNotifyCustomerMobileOtpReducer } from '../../slices/gq-notification';

export const notifyMobileOtpReducers = {
    postNotifyCustomerMobileOtp: postNotifyCustomerMobileOtpReducer
};